<template>
  <TitleWrapper
    title="LESSON_PLANNER"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <LessonPlannerPermission />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <LessonPlannerNotification />
  </div>
</template>

<script>
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import LessonPlannerNotification from '@src/router/views/settings/notifications/lesson-planner/LessonPlannerNotification.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import LessonPlannerPermission from '@src/router/views/settings/system-settings/LessonPlannerSettingsView.vue'
import UITabs from '@src/components/UiElements/UITabs.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
export default {
  name: 'Settings',
  components: {
    UITabs,
    TitleWrapper,
    NoRecordFound,
    LessonPlannerNotification,
    LessonPlannerPermission,
  },

  page: {
    title: 'Features Settings',
  },
  data() {
    return {
      FEATURES_TABS,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },
}
</script>
